<head>
  <title>Forms and Logs Reports</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="col-md-6">
    <div class="row">
      <app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
    </div>
    <div class="row">
      <div *ngIf="qmsservice.formsAndLogsReportFor  === 'Form Section Data'">
        <div class="d-flex">
          <div class="col-md-4">
            <div><label for="email" id="templateAlert">Select Template <span class="mandatory-symbol">*</span> :</label>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedFormTemplateType"
              (closed)="templateTypeSearchText=''" (click)="focusSearch('template-type-search')" (keydown.enter)="focusSearch('template-type-search')">
              <input type="search" id="template-type-search" class="dropdownsearchstyle"
                [(ngModel)]="templateTypeSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onTemplateSelectionChange($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of templateDropDown | assessmentSearch : templateTypeSearchText;"
                (onSelectionChange)="onTemplateSelectionChange($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-4">
            <div><label for="email">Select Forms</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedFromType" (closed)="fromTypeSearchText=''"
              (click)="focusSearch('from-type-search')" (keydown.enter)="focusSearch('from-type-search')">
              <input type="search" id="from-type-search" class="dropdownsearchstyle" [(ngModel)]="fromTypeSearchText"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onTemplateFromSelectionChange($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of sectionFromDropDown | assessmentSearch : fromTypeSearchText;"
                (onSelectionChange)="onTemplateFromSelectionChange($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="col-md-4"*ngIf="selectedFromType">
          <div><label for="email">Select Section</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedsectionType"
            (closed)="SectionTypeSearchText=''" (click)="focusSearch('Section-type-search')" (keydown.enter)="focusSearch('Section-type-search')">
            <input type="search" id="Section-type-search" class="dropdownsearchstyle"
              [(ngModel)]="SectionTypeSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onTemplateFromSectionSelectionChange($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of sectionTemplateFromDropDown | assessmentSearch : SectionTypeSearchText;"
              (onSelectionChange)="onTemplateFromSectionSelectionChange($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.formsAndLogsReportFor  === 'Template Vs Users'">
        <div><label for="email">Select Template :</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTemplateType"
          (closed)="templateTypeSearchText=''" (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" id="focus-title-search" class="dropdownsearchstyle" [(ngModel)]="templateTypeSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onTemplateSelectnew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of templateDropDown | assessmentSearch : templateTypeSearchText;"
            (onSelectionChange)="onTemplateSelectnew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.formsAndLogsReportFor  === 'Forms Vs Users'">
        <div><label for="email">Select Forms</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedFromType" (closed)="fromTypeSearchText=''"
          (click)="focusSearch('from-type-search')" (keydown.enter)="focusSearch('from-type-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="fromTypeSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onFromSelectnew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of fromDropDown | assessmentSearch : fromTypeSearchText;"
            (onSelectionChange)="onFromSelectnew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="row" d-flex align-items-center>
        <br>
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton" (click)="getcallMethod()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.formsAndLogsReportFor  === 'Default'}"
        (click)="moreFormsAndLogsReportDetails('Default')" (keydown.enter)="moreFormsAndLogsReportDetails('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.formsAndLogsReportFor  === 'Form Section Data'}"
        (click)="moreFormsAndLogsReportDetails('Form Section Data')" (keydown.enter)="moreFormsAndLogsReportDetails('Form Section Data')">
        <div class="reports_block">
          <img src="../../assets/img/download-cloud.png" width="16px" height="16px" alt="Form Section Data">
        </div>
        <p class="report_subtext">Form Section Data</p>
      </div>
      <div class="d-flex gap-2 align-items-center  report"
        [ngClass]="{'active':this.qmsservice.formsAndLogsReportFor  === 'Template Vs Users'}"
        (click)="moreFormsAndLogsReportDetails('Template Vs Users')" (keydown.enter)="moreFormsAndLogsReportDetails('Template Vs Users')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/web-design.png" width="16px" height="16px" alt="Template Vs Users">
        </div>
        <p class="report_subtext">Template Vs Users</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center  report"
        [ngClass]="{'active':this.qmsservice.formsAndLogsReportFor  === 'Forms Vs Users'}"
        (click)="moreFormsAndLogsReportDetails('Forms Vs Users')" (keydown.enter)="moreFormsAndLogsReportDetails('Forms Vs Users')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/work.png" width="16px" height="16px" alt="Forms Vs Users">
        </div>
        <p class="report_subtext">Forms Vs Users</p>
      </div>
    </div>
  </div>
  <hr>
  <div *ngIf="showReportFlagValue">
    <div class="table-container" *ngIf="qmsservice.formsAndLogsReportFor  === 'Form Section Data' && pagedItems2.length > 0">
      <div class="row">
        <div class="col-8"></div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
      </div>&nbsp;&nbsp;
      <div class="table-container">
        <table style="height: 60vh;">
          <thead>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Section Name</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('sectionName', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Form Name</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('formName', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Status</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('status', $event,'s')" />
              </div>
            </th>

            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Is Verified</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('isVerified', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Verification Requested On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('verificationRequestedOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Verified By User</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('verifiedByUser', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Verified On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('verifiedOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Verifier Comments</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('verifierComments', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Locked By User</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('lockedByUser', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Created On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('createdOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Created By User</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('createdByUser', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Updated On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('updatedOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Updated By User</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter2('updatedByUser', $event,'s')" />
              </div>
            </th>
            <th  class="sticky-col first-col"></th>
          </thead>
          <tr *ngIf="pagedItems2.length === 0">
            <td class="row-data text-center" colspan="15">No records found</td>
          </tr>
          <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
            <td class="row-data">{{ listOfUsersData.sectionName}}</td>
            <td class="row-data">{{ listOfUsersData.formName }}</td>
            <td class="row-data">{{ listOfUsersData.status }}</td>
            <td class="row-data">
              <div class="icon-container">
                <img *ngIf="listOfUsersData.isVerified === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20" alt="Access granted symbol">
                <img *ngIf="listOfUsersData.isVerified === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" alt="Access granted symbol">
              </div>
            </td>
            <td class="row-data">{{ listOfUsersData.verificationRequestedOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.verifiedByUser }}</td>
            <td class="row-data">{{ listOfUsersData.verifiedOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.verifierComments }}</td>
            <td class="row-data">{{ listOfUsersData.lockedByUser }}</td>
            <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
            <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
          </tr>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" 
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="qmsservice.formsAndLogsReportFor  === 'Template Vs Users'">
      <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
        <div class="">
          <div class="search-container">
            <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
              [(ngModel)]="searchValue">
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="">
          <div class="d-flex gap-2 action-buttons-container">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
              <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
              <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">PDF Report</span>
            </div>
          </div>
        </div>
      </div>
      <table class="dynamic-table-container documentTable">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i id="" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th id="grid-header-container"
          *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
          [ngStyle]="{'min-width': taskDocumentsDataForGridData.width, 'max-width': taskDocumentsDataForGridData.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
          class="sticky-dynamic-col1">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{taskDocumentsDataForGridData.fieldColumnarray}}</span>
            <div class="d-flex gap-2 align-items-center">
              <div>
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
        </th>
        <th  class="sticky-col first-col"></th>
        <!-- search input row is added -->
        <tr>
          <td [class]="
                makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
              "></td>
          <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
            class="sticky-dynamic-col1">
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
            </div>
          </td>
        </tr>
        <!-- data row -->
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
          [class.highlightRow]="list.childCheckBoxs == true">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'200px','max-width':'200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">

            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
                  height="16" alt="access" />
                <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
                  width="16" height="16" alt="no access" />
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'&& list[key.columnsListarray] !='htmlClobView'">{{
              list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" 
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="qmsservice.formsAndLogsReportFor  === 'Forms Vs Users'">
      <div class="d-flex justify-content-end gap-3 mt-1 mb-3">
        <div class="">
          <div class="search-container">
            <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
              [(ngModel)]="searchValue">
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="">
          <div class="d-flex gap-2 action-buttons-container">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
              <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
              <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">PDF Report</span>
            </div>
          </div>
        </div>
      </div>
      <table class="dynamic-table-container documentTable">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th id="grid-header-container"
          *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
          [ngStyle]="{'min-width': taskDocumentsDataForGridData.width, 'max-width': taskDocumentsDataForGridData.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
          class="sticky-dynamic-col1">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{taskDocumentsDataForGridData.fieldColumnarray}}</span>
            <div class="d-flex gap-2 align-items-center">
              <div>
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
        </th>
        <th  class="sticky-col first-col"></th>        <!-- search input row is added -->
        <tr>
          <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></td>
          <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
            class="sticky-dynamic-col1">
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
            </div>
          </td>
        </tr>
        <!-- data row -->
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
          [class.highlightRow]="list.childCheckBoxs == true">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'200px','max-width':'200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
                  height="16" alt="access" />
                <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
                  width="16" height="16" alt="no access" />
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'&& list[key.columnsListarray] !='htmlClobView'">{{
              list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" 
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end details grid-->
  <!--Excell & pdf -->
  <ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
      <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
      <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
        }}
        ?</label>
    </div>
    <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
      <label for="email" style="font-size: .7rem; font-weight: bold;">
        <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
        <span *ngIf="manuallyPicked && maxCountReached">
          We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
        </span>
      </label>
    </div>
    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
      <div class="col-md-12" *ngIf="selectedColumns.length">
        <div><label for="email">Selected Column(s)</label></div>
        <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
          rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
      </div>
      <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
        <div class="col-md-6">
          <label for="radio">PDF Page Size</label>
          <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
            <mat-radio-button *ngFor="let data of pdfPageSizes"
              [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-md-6" style="margin-top: 1.5%;">
          <label for="toggle">Pick Columns Manually?</label>&nbsp;
          <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
            id="toggle">
            <ng-container *ngIf="manuallyPicked; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row mt-3" *ngIf="manuallyPicked">
        <div class="col-md-12">
          <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
            (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')" (keydown.enter)="focusSearch('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
              [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="!isForExcel">
        <div class="col-sm-4">
          <label  for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
            
                <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="!isForExcel">
        <div class="col-sm-4">
          <label  for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">       
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
          </ng-template>
      </mat-slide-toggle>  
      </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label  for="email">Report Name</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">       
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
      </div>
   
    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
      <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
        <i class="fa fa-file-excel-o"></i> Generate
      </button>
      <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
        <i class="fa fa-file-pdf-o"></i> Generate
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
  <app-editor #clobViewPopup></app-editor>
  <app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>